<div class="itinerary-content">
  <div class="row">
    <div class="col-2" *ngIf="vehicleHasDoors()">
      <span class="itinerary-icons">
        <app-service-icon [icon]="'car-side'" [customPath]="getServiceIconPath('car-side')"></app-service-icon>
      </span>
      <span>x {{ vehicle?.services?.doors }}</span>
    </div>
    <div class="col-2" *ngIf="vehicleHasPassengers()">
      <span class="itinerary-icons"><em class="fas fa-male"></em></span>
      <span>x {{ vehicle?.services?.passengerQuantity }}</span>
    </div>
    <div class="col-2" *ngIf="vehicleHasBaggages()">
      <span class="itinerary-icons"><em class="fas fa-suitcase"></em></span>
      <span>x {{ vehicle?.services?.baggageQuantityMax }}</span>
    </div>
    <div class="col-2" *ngIf="vehicle?.services?.transmission !== 'Transmission undefined'">
      <span class="itinerary-icons"><em class="fas fa-cog"></em></span>
      <span>{{vehicleGearBox()}}</span>
    </div>
    <div class="col-2" *ngIf="vehicle.services?.airConditioned">
      <span class="itinerary-icons"><em class="fas fa-snowflake"></em></span>
      <span>A/C</span>
    </div>
    <div class="col-12 text-right" *ngIf="vehicle.oneWay">
      <span style="font-size: 13px; line-height: 14px; text-align: left;">{{ 'ITINERARY.VEHICLE.ONEWAY' | translate }}
        {{vehicle.oneWay}}</span>
    </div>
  </div>
</div>